import Avatar from 'components/Avatar'
import BrowseDefaultIcon from 'components/icons/BrowseDefaultIcon'
import RightArrow from 'components/icons/RightArrow'
import React from 'react'

import {
  MainHeading,
  SecondGreyText,
  SubFLex,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const SocialMediaLinks = ({ socialMediaDetails }) => {
  return (
    <>
      <MainHeading>Social Media Links</MainHeading>

      <SubFLex gap={'10px'} column>
        {socialMediaDetails?.map((item, index) => (
          <a href={item?.link} key={index + item?.link}>
            <SubFLex centerVertically gap="10px">
              <div>
                <Avatar
                  src={''}
                  size={24}
                  icon={<BrowseDefaultIcon />}
                  background="none"
                />
              </div>
              <SecondGreyText marginBottom="0">{item?.link}</SecondGreyText>
              <RightArrow />
            </SubFLex>
          </a>
        ))}
      </SubFLex>
    </>
  )
}

export default SocialMediaLinks
